import RegionModel from 'Models/RegionModel';

const WowWotlkModel = {};

// Не забудь обновить бэк.
// @see \App\Types\Maps\ServerMap -> ProductGameEnum::GAME_WOW_BC -> RegionMap::REGION_ID_EU
WowWotlkModel[RegionModel.EU.id] = [
  {
    id: 1,
    title: 'Amnennar',
  },
  {
    id: 2,
    title: 'Ashbringer',
  },
  {
    id: 3,
    title: 'Auberdine',
  },
  {
    id: 4,
    title: 'Bloodfang',
  },
  {
    id: 5,
    title: 'Celebras',
  },
  {
    id: 6,
    title: 'Chromie',
  },
  {
    id: 7,
    title: "Dragon's Call",
  },
  {
    id: 8,
    title: 'Dragonfang',
  },
  {
    id: 9,
    title: 'Dreadmist',
  },
  {
    id: 10,
    title: 'Earthshaker',
  },
  {
    id: 11,
    title: 'Everlook',
  },
  {
    id: 12,
    title: 'Finkle',
  },
  {
    id: 13,
    title: 'Firemaw',
  },
  {
    id: 14,
    title: 'Flamegor',
  },
  {
    id: 15,
    title: 'Flamelash',
  },
  {
    id: 16,
    title: 'Gandling',
  },
  {
    id: 17,
    title: 'Gehennas',
  },
  {
    id: 44,
    title: 'Giantstalker',
  },
  {
    id: 18,
    title: 'Golemagg',
  },
  {
    id: 19,
    title: 'Harbinger of Doom',
  },
  {
    id: 20,
    title: 'Heartstriker',
  },
  {
    id: 21,
    title: 'Hydraxian Waterlords',
  },
  {
    id: 46,
    title: 'Jin\'do',
  },
  {
    id: 22,
    title: 'Judgement',
  },
  {
    id: 23,
    title: 'Lakeshire',
  },
  {
    id: 24,
    title: 'Lucifron',
  },
  {
    id: 25,
    title: 'Mandokir',
  },
  {
    id: 26,
    title: 'Mirage Raceway',
  },
  {
    id: 27,
    title: 'Mograine',
  },
  {
    id: 28,
    title: 'Nethergarde Keep',
  },
  {
    id: 29,
    title: 'Noggenfogger',
  },
  {
    id: 30,
    title: 'Patchwerk',
  },
  {
    id: 31,
    title: 'Pyrewood Village',
  },
  {
    id: 32,
    title: 'Razorfen',
  },
  {
    id: 33,
    title: 'Razorgore',
  },
  {
    id: 34,
    title: "Rhok'delar",
  },
  {
    id: 35,
    title: 'Shazzrah',
  },
  {
    id: 36,
    title: 'Skullflame',
  },
  {
    id: 37,
    title: 'Stonespine',
  },
  {
    id: 38,
    title: 'Sulfuron',
  },
  {
    id: 39,
    title: 'Ten Storms',
  },
  {
    id: 45,
    title: 'Thekal',
  },
  {
    id: 40,
    title: 'Transcendence',
  },
  {
    id: 41,
    title: 'Venoxis',
  },
  {
    id: 42,
    title: 'Wyrmthalak',
  },
  {
    id: 43,
    title: 'Zandalar Tribe',
  },
];

// Не забудь обновить бэк.
// @see \App\Types\Maps\ServerMap -> ProductGameEnum::GAME_WOW_BC -> RegionMap::REGION_ID_USA
WowWotlkModel[RegionModel.USA.id] = [
  {
    id: 1,
    title: 'Anathema',
  },
  {
    id: 2,
    title: 'Arcanite Reaper',
  },
  {
    id: 46,
    title: 'Angerforge',
  },
  {
    id: 3,
    title: 'Arugal',
  },
  {
    id: 4,
    title: 'Ashkandi',
  },
  {
    id: 5,
    title: 'Atiesh',
  },
  {
    id: 6,
    title: 'Azuresong',
  },
  {
    id: 7,
    title: 'Benediction',
  },
  {
    id: 8,
    title: 'Bigglesworth',
  },
  {
    id: 9,
    title: 'Blaumeux',
  },
  {
    id: 10,
    title: 'Bloodsail Buccaneers',
  },
  {
    id: 11,
    title: 'Deviate Delight',
  },
  {
    id: 12,
    title: 'Earthfury',
  },
  {
    id: 47,
    title: 'Eranikus',
  },
  {
    id: 13,
    title: 'Faerlina',
  },
  {
    id: 14,
    title: 'Fairbanks',
  },
  {
    id: 15,
    title: 'Felstriker',
  },
  {
    id: 16,
    title: 'Grobbulus',
  },
  {
    id: 17,
    title: 'Heartseeker',
  },
  {
    id: 18,
    title: 'Herod',
  },
  {
    id: 19,
    title: 'Incendius',
  },
  {
    id: 20,
    title: 'Kirtonos',
  },
  {
    id: 21,
    title: 'Kromcrush',
  },
  {
    id: 22,
    title: 'Kurinnaxx',
  },
  {
    id: 23,
    title: 'Loatheb',
  },
  {
    id: 44,
    title: 'Maladath',
  },
  {
    id: 24,
    title: 'Mankrik',
  },
  {
    id: 25,
    title: 'Myzrael',
  },
  {
    id: 26,
    title: 'Netherwind',
  },
  {
    id: 42,
    title: 'Obsidian Edge',
  },
  {
    id: 27,
    title: 'Old Blanchy',
  },
  {
    id: 28,
    title: 'Pagle',
  },
  {
    id: 43,
    title: 'Perdition\'s Blade',
  },
  {
    id: 29,
    title: 'Rattlegore',
  },
  {
    id: 30,
    title: 'Remulos',
  },
  {
    id: 31,
    title: 'Skeram',
  },
  {
    id: 45,
    title: 'Skyfury',
  },
  {
    id: 32,
    title: 'Smolderweb',
  },
  {
    id: 33,
    title: 'Stalagg',
  },
  {
    id: 34,
    title: "Sul'thraze",
  },
  {
    id: 35,
    title: 'Sulfuras',
  },
  {
    id: 36,
    title: 'Thalnos',
  },
  {
    id: 37,
    title: 'Thunderfury',
  },
  {
    id: 38,
    title: 'Westfall',
  },
  {
    id: 39,
    title: 'Whitemane',
  },
  {
    id: 40,
    title: 'Windseeker',
  },
  {
    id: 41,
    title: 'Yojamba',
  },
];

// eslint-disable-next-line import/prefer-default-export
export { WowWotlkModel };
